<template>
  <div>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="12">
        <el-form-item :label="$t('path')" prop="path">
          <el-input maxlength="255" ref="path" v-model="ruleForm.path"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
        <el-form-item :label="$t('usuario')" prop="username">
          <el-input maxlength="255" ref="username" v-model="ruleForm.username"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
        <el-form-item :label="$t('senha')" prop="password">
          <el-input type="password" maxlength="255" v-model="ruleForm.password"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  computed: {
    data() {
      return this.ruleForm;
    }
  },
  name: "ShippingAddFormConfigBearer",
  methods: {
    setData(ruleForm) {
      this.rulleForm.path = ruleForm.config.path;
      this.rulleForm.username = ruleForm.config.username;
      this.rulleForm.password = ruleForm.config.password;
    }
  },
  data() {
    return {
      ruleForm: {
        path: "",
        username: "",
        password: "",
      },
    };
  },
};
</script>
